import { Box } from '@mui/material'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import CustomisedCardLine from '../../../components/card/cardLine'
import ElementTitle from '../../../components/title/elementTitle/elementTitle'
import { IGetCustomerInfoResponse } from '../../../models/customer.model'
import { changeRouteType, getpervInnerState } from '../../../redux/handleBackBtn/handleBackBtnSlice'
import { setHeaderTitle } from '../../../redux/headerTitle/headerTitleSlice'
import PersonIcon from '@mui/icons-material/Person';
import BadgeIcon from '@mui/icons-material/Badge';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import MailBox from '../../../components/icons/MailBox'


const UserProfile = ({ profile }: { profile: IGetCustomerInfoResponse }) => {
    const dispatch = useDispatch()
    const randomKeyForDispatch = Math.random();
    useEffect(() => {
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: `profile ${randomKeyForDispatch}` }));
        dispatch(setHeaderTitle({ header: 'پروفایل کاربر', color: 'var(--header-color)', parentRoute: '', }));
    }, [])

    return (
        <div className='h-[calc(100svh-120px)] overflow-y-auto'>
            <Box sx={{ paddingInline: "20px", marginTop: "20px", display: "flex", flexDirection: "column", gap: "7px" }}>
                <ElementTitle title='اطلاعات پروفایل' />
                <CustomisedCardLine itemList={[{
                    title: <><PersonIcon sx={{ marginLeft: "5px" }} />نام و نام خانوادگی</>
                    , value: profile.fullName
                },
                {
                    title: <><BadgeIcon sx={{ marginLeft: "5px" }} />کد ملی</>
                    , value: profile.nationalCode
                },
                {
                    title: <><CalendarMonthIcon sx={{ marginLeft: "5px" }} />تاریخ تولد</>,
                    value: profile.birthDatePersian
                }, {
                    title: <><PhoneIphoneIcon sx={{ marginLeft: "5px" }} />شماره موبایل</>,
                    value: profile.mobileNumber
                }]} />
            </Box>
            {profile?.addresses?.length! > 0 && <Box sx={{ paddingInline: "20px", marginTop: "20px", display: "flex", flexDirection: "column", gap: "7px" }}>
                <ElementTitle title='آدرس و کد پستی' />
                {profile?.addresses?.map((item, index) => (
                    <CustomisedCardLine key={index} itemList={[{
                        title: <><MailBox sx={{ marginLeft: "5px", fontSize: "20px", marginBottom: "5px" }} />کد پستی</>
                        ,
                        value: item.postalCode
                    }, { value: item.address }]} />
                ))}
            </Box>}
        </div>
    )
}

export default UserProfile